import React, { useState, useEffect, useRef} from 'react';
import language from '../../../utils/LanguageSettings';
import RenderSnA from '../../functions/renderSnA';
import { fetchHome } from '../../functions/fetchHome';
import { filterCustomerTypeDisplayForHome } from '../../functions/filterCustomerTypeDisplay';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import removeButton from '../../../images/icons/mw-remove.png';
import noticeIcon from '../../../images/icons/notice-icon.png';
import HomeBanner from './HomeBanner';
import HomeFullscreenTemplate from './HomeFullscreenTemplate';
import HomeComboSplitTemplate from './HomeComboSplitTemplate';
import HomeHtmlEditor from './HomeHtmlEditor';
import HomeNewSplitTemplate from './HomeNewSplitTemplate';
import HomeTncModal from './HomeTncModal';
import HomeVideoModal from './HomeVideoModal';
import '../../../css/homepage.css';

interface HomeProps {

}

const Home: React.FC<HomeProps> = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [homeBanner, setHomeBanner] = useState<any[]>([]);
    const [announcement, setAnnouncement] = useState<any[]>([]);
    const [featuredSection, setFeaturedSection] = useState<any[]>([]);
    const [featuredContent, setFeaturedContent] = useState<any[]>([]);
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);

    const featuredItems: React.SetStateAction<any[]> = [];

    useEffect(() => {
        // Temporarily disable the browser's automatic scroll restoration.
        // This prevents the browser from jumping to the previous scroll position after a language-change reload.
        if (window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
        // Immediately scroll to the top of the page.
        window.scrollTo(0, 0);

        // Add 'home' class to body
        document.body.classList.add('home');

        const fetchData = async () => {
            let data = await fetchHome(language);
            if(data){
                setAnnouncement(filterByActiveStatusAndPublishDateTime(data?.data?.attributes?.Announcement));
                setHomeBanner(filterByActiveStatusAndPublishDateTime(filterCustomerTypeDisplayForHome(data?.data?.attributes?.HomepageBanner)));
                setFeaturedSection(filterByActiveStatusAndPublishDateTime(filterCustomerTypeDisplayForHome(data?.data?.attributes?.FeaturedSection)));
                handleFeatured(featuredSection);
                setLoading(false);
                setGa(data?.data?.attributes?.GA || null);
                setSeo(data?.data?.attributes?.SEO || null);
            }
        };
        fetchData();

        // Return a cleanup function to restore the default browser behavior when the component unmounts.
        return () => {
            if (window.history.scrollRestoration) {
                window.history.scrollRestoration = 'auto';
            }
            // Remove 'home' class when component unmounts
            document.body.classList.remove('home');
        };
    }, [language]);

    useEffect(()=>{
        handleFeatured(featuredSection);
    },[featuredSection,language]);

    useEffect(()=>{
        handleAnnouncementPlace();
    },[announcement,language]);


    const handleAnnouncementPlace = () => {
        const mainElement = document.getElementById('main');
        if(announcement.length > 0) {
            if (mainElement) {
                mainElement.classList.add('has-announcement');
            }
            const announcementElement = document.querySelector('.announcement-scroller-wrap.main-announcement');
            const headerElement = document.querySelector('header') || document.querySelector('body');
            if (announcementElement && headerElement && headerElement.parentNode) {
                headerElement.parentNode.insertBefore(announcementElement, headerElement);
            }
            document.body.classList.add('withnotification');
        }else{
            if (mainElement) {
                mainElement.classList.add('no-announcement');
            }
        }

        const closeButton = document.querySelector(".close-main-notice");
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                setTimeout(function() {
                document.body.classList.remove('withnotification');
                if (mainElement) {
                    mainElement.classList.add('normal');
                }
                const announcementElements = [
                    ...document.querySelectorAll('.announcement-notice'),
                    ...document.querySelectorAll('.announcement-scroller-wrap')
                ];
                announcementElements.forEach(el => {
                    el.classList.add('closed');
                    el.style.display = 'none';
                });
                }, 400);
            });
        }
    }

    const handleFeatured = (item: any) => {
        setFeaturedContent([]);
        item?.forEach((element: {__component: string}, index: number) => {
            switch(element?.__component){
                case "home.fullscreen-template":
                    featuredItems.push(<HomeFullscreenTemplate element={element} key={index}/>);
                    break;
                case "home.combo-split-template":
                    featuredItems.push(<HomeComboSplitTemplate element={element} key={index}/>);
                    break;
                case "home.html-editor":
                    featuredItems.push(<HomeHtmlEditor element={element} key={index}/>);
                    break;
                case "home.new-split-template":
                    featuredItems.push(<HomeNewSplitTemplate element={element} key={index}/>);
                    break;
            }
        });
        setFeaturedContent(featuredItems);
    }

    const filterByActiveStatusAndPublishDateTime = (item: any[]) => {

        const isValidItem = (singleItem: any) =>
            singleItem?.Status === "Active" &&
            new Date(singleItem?.PublishStartDateTime) <= new Date() &&
            (singleItem?.PublishEndDateTime === null || new Date(singleItem?.PublishEndDateTime) >= new Date());

        return item.filter(isValidItem);
    };

    const handleAnnouncement = (announcement: any[]) => {
        if(announcement?.length > 0){
            if(announcement?.length == 1){
                return <>
                    <div className='announcement-scroller-wrap main-announcement'>
                        {handleAnnouncementContent(announcement)}
                    </div>
                </>
            } else {
                return <>
                    <div className='announcement-scroller-wrap main-announcement'>
                        <div className='announcement-scroller owl-carousel text-center'>
                            {handleAnnouncementContent(announcement)}
                        </div>
                    </div>
                </>
            }
        }
    }

    const handleAnnouncementContent = (announcement: any[]) => {
        return Array.isArray(announcement) && announcement.map((item, index) => (
                <div key={index} id="notice" className="announcement-notice py-4" style={{color: item?.TextColor, backgroundColor: item?.BackgroundColor}}>
                    <div className="container-fluid">
                        <a type="button" className="close-notice close-main-notice">
                            <img src={removeButton} alt=""/>
                        </a>
                        <img src={noticeIcon} className="mr-5 d-inline-block notice-img"/>
                        <div className="subscribe-text d-inline-block align-top">
                            <p className="lg_font_size light-gray barlow-font">
                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.Text}</ReactMarkdown>
                            </p>
                        </div>
                    </div>
                </div>
            ));
    }

  
    if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }
    return (
      <>
        <RenderSnA seo={seo} ga={ga} />
        <div className='homepage'>
            {homeBanner?.length > 0 ? 
            <section id='sliding-banner'>
                <div className='position-absolute' id='youtube-custom-control'>
                    <button id='play-video' className='video-control' data-func='playVideo'></button>
                    <button id='stop-video' className='video-control' data-func='stopVideo'></button>
                </div>
                {handleAnnouncement(announcement)}
                <div className='flexslider mb-0'>
                    <div className='slides'>
                        <HomeBanner element={homeBanner} />
                    </div>
                </div>
            </section>
            : <></>}
            {featuredContent ? featuredContent : <></>}
        </div>
        <HomeTncModal />
        <HomeVideoModal />
      </>
    );
};

export default Home;